import React from "react";

const CloseButton = (props) => {
  return (
    <button className="modal-close-button" onClick={props.handleOnClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="61"
        height="61"
        viewBox="0 0 61 61"
        fill="none"
        role="img"
      >
        <path
          d="M39.65 21.35L21.35 39.65"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.35 21.35L39.65 39.65"
          stroke="white"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

export default CloseButton;
